#wrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: var(--spacer);
}

.title {
  margin-top: calc(var(--spacer) * 1.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

#custom-fields-details-text {
  margin: calc(var(--spacer) * 2) 0 0 0;
  color: var(--chart-300-icon-buttons);
  max-width: 650px;
  line-height: 21px;
}

#custom-fields-form {
  width: 100%;
  height: auto;
}
